import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import { CaretRight, ListDashes } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CategorySidebar = ({ limit = 10 }) => {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [cats, setCats] = useState([]);

  useEffect(() => {
    axios.get(`${API}/shop/categories`).then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const go = (id) => navigate(`/shop?category=${id}`);

  return (
    <div className="relative z-30 bg-[#2e3a47] text-white" data-testid="category-sidebar">
      <div className="flex items-center gap-2 bg-[#243039] px-5 py-3 text-sm font-bold uppercase tracking-wide">
        <ListDashes size={18} weight="bold" /> {t.categories}
      </div>
      {cats.slice(0, limit).map((c) => (
        <div key={c.category_id} className="group relative border-b border-white/5">
          <button
            data-testid={`sidebar-cat-${c.category_id}`}
            onClick={() => go(c.category_id)}
            className="flex w-full items-center justify-between px-5 py-3 text-left text-[13px] font-semibold uppercase tracking-wide transition-colors duration-150 group-hover:bg-[#465f73]"
          >
            <span className="truncate pr-2">{c.name[lang] || c.name.fr}</span>
            {c.children?.length > 0 && <CaretRight size={13} weight="bold" className="shrink-0" />}
          </button>
          {c.children?.length > 0 && (
            <div className="invisible absolute left-full top-0 z-40 min-w-[260px] border border-border bg-white text-foreground opacity-0 shadow-2xl transition-opacity duration-150 group-hover:visible group-hover:opacity-100">
              {c.children.map((ch) => (
                <button
                  key={ch.category_id}
                  onClick={() => go(ch.category_id)}
                  className="block w-full truncate px-5 py-2.5 text-left text-[13px] uppercase tracking-wide hover:bg-muted hover:text-primary transition-colors duration-150"
                >
                  {ch.name[lang] || ch.name.fr}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
      <button onClick={() => navigate("/shop")} className="block w-full px-5 py-3 text-left text-[13px] font-semibold uppercase tracking-wide hover:bg-[#465f73] transition-colors duration-150">
        {t.moreCategories}
      </button>
    </div>
  );
};
